import { useTranslation } from "react-i18next";
var PropertiesConstants = function () {
    var t = useTranslation().t;
    return {
        areusure: t("com.beo.dakz.areusure"),
        yes: t("com.beo.dakz.yes"),
        no: t("com.beo.dakz.no"),
        confirm: t("com.beo.dakz.confirm"),
        select: t("com.beo.dakz.select"),
        slno: t("com.beo.dakz.slno"),
        tabActions: t("com.beo.dakz.tab.column.actions"),
        yesNoOptions: [t("com.beo.dakz.yes"), t("com.beo.dakz.no")],
        latestRcvDetails: t("com.beo.dakz.latestRcvDetails"),
        latestSendDetails: t("com.beo.dakz.latestSendDetails"),
        msgsummaryreport: t("com.beo.dakz.msgsummaryreport"),
        overallstatusreport: t("com.beo.dakz.overallstatusreport"),
        emptyMessage: t("com.beo.dakz.datatable.emptymessage"),
        button: {
            add: t("com.beo.dakz.button.add"),
            clear: t("com.beo.dakz.button.clear"),
            refresh: t("com.beo.dakz.button.refresh"),
            delete: t("com.beo.dakz.button.delete"),
            submit: t("com.beo.dakz.button.submit"),
            save: t("com.beo.dakz.button.save"),
            print: t("com.beo.dakz.button.print"),
            edit: t("com.beo.dakz.button.edit"),
            update: t("com.beo.dakz.button.update"),
            upload: t("com.beo.dakz.button.upload"),
            list: t("com.beo.dakz.button.list"),
        },
        menu: {
            profile: t("com.beo.dakz.menu.profile"),
            settings: t("com.beo.dakz.menu.settings"),
            logout: t("com.beo.dakz.menu.logout"),
        },
        settings: {
            customizePreferences: t("com.beo.dakz.settings.customizePreferences"),
            theme: t("com.beo.dakz.settings.theme"),
            language: t("com.beo.dakz.settings.language"),
            fieldToggle: t("com.beo.dakz.settings.fieldToggle"),
            generalSettings: t("com.beo.dakz.settings.generalSettings"),
            featureToggles: t("com.beo.dakz.settings.featureToggles"),
            showUserCard: t("com.beo.dakz.settings.showUserCard"),
            showClientCard: t("com.beo.dakz.settings.showClientCard"),
            showMessageCard: t("com.beo.dakz.settings.showMessageCard"),
            listingPreferences: t("com.beo.dakz.settings.listingPreferences"),
            DefaultRecordsPP: t("com.beo.dakz.settings.DefaultRecordsPP"),
            MsgDefaultRecordsPT: t("com.beo.dakz.settings.MsgDefaultRecordsPT"),
        },
        interface: {
            upload: {
                dialogTitle: t("com.beo.dakz.interface.upload.dialogTitle"),
                successMessage: t("com.beo.dakz.interface.upload.successMessage"),
                noDataMessage: t("com.beo.dakz.interface.upload.noDataMessage"),
            },
            chooseXml: t("com.beo.dakz.interface.form.chooseXmlFile"),
            selectXmlFile: t("com.beo.dakz.interface.form.selectXmlFile"),
            parse: t("com.beo.dakz.interface.form.parse"),
            userId: t("com.beo.dakz.interface.columns.userId"),
            messageId: t("com.beo.dakz.interface.columns.messageId"),
            messageType: t("com.beo.dakz.interface.columns.messageType"),
            status: t("com.beo.dakz.interface.columns.status"),
        },
        message: {
            savedToDatabase: t("com.beo.dakz.message.savedToDatabase"),
            errorOnSave: t("com.beo.dakz.message.errorOnSave"),
            warning: t("com.beo.dakz.message.warning"),
            Info: t("com.beo.dakz.message.Info"),
        },
        nonstampableitem: {
            heading: t("com.beo.dakz.nonstampableitem.heading"),
            itemno: t("com.beo.dakz.nonstampableitem.itemno"),
            itemdescription: t("com.beo.dakz.nonstampableitem.itemdescription"),
            category: t("com.beo.dakz.nonstampableitem.category"),
        },
        requiredValidation: t("com.beo.dakz.rule.required"),
        default: t("com.beo.dakz.default"),
    };
};
export default PropertiesConstants;
